"use strict";
export const MemberAuditMock = (mock) => {
  mock.onGet("/api/v7/team/members/audit").reply((config) => {
    let response = {
      "model": "grid.result",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "member.info",
            "name": "ding",
            "phone": "18712701715",
            "status": "wait",
            "remark": "ding",
            "type": "apply",
            "member_guid": "invite_user_3861243e6ba14769b6ee9e58c85e898a",
            "apply_time": 1615346148e3,
            "audit_time": null,
            "apply_no": "0093"
          },
          {
            "model": "member.info",
            "name": "\u4E01",
            "phone": "18712701715",
            "status": "pass",
            "remark": "ding",
            "type": "apply",
            "member_guid": "invite_user_bd8c6300f5c14214ac34b6f886c70c02",
            "apply_time": 1615288541e3,
            "audit_time": 161528947e4,
            "apply_no": "0092"
          },
          {
            "model": "member.info",
            "name": "\u4E01",
            "phone": "18712701715",
            "status": "refuse",
            "remark": "ding",
            "type": "apply",
            "member_guid": "invite_user_0d86d40fffaf4733b01a998831880d91",
            "apply_time": 161528777e4,
            "audit_time": 1615288539e3,
            "apply_no": "0091"
          },
          {
            "model": "member.info",
            "name": "\u4E01",
            "phone": "18712701715",
            "status": "remove",
            "remark": "ding",
            "type": "apply",
            "member_guid": "invite_user_b3ea29adbcd14b48ae18dea016523e6a",
            "apply_time": 1615275145e3,
            "audit_time": 1615275145e3,
            "apply_no": "0090"
          },
          {
            "model": "member.info",
            "name": "\u738B\u6668",
            "phone": "15242957219",
            "status": "remove",
            "remark": null,
            "type": "apply",
            "member_guid": "invite_user_3be649eda52841f9b5da1dd7a0971e73",
            "apply_time": 1613967758e3,
            "audit_time": 1613967758e3,
            "apply_no": "0089"
          },
          {
            "model": "member.info",
            "name": "\u6D69\u7136",
            "phone": "15122077647",
            "status": "pass",
            "remark": null,
            "type": "apply",
            "member_guid": "invite_user_2749fef241074086a8e81269a4c6abdf",
            "apply_time": 1612494865e3,
            "audit_time": 1612494865e3,
            "apply_no": "0088"
          }
        ],
        "total": 6
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 6,
        "size": 10
      }
    };
    return [200, response];
  });
};
